import loading from './loading'

export default {
  install(vue) {
    vue.prototype.$loading = new loading(vue)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/index.js